import { styled } from "@linaria/react"
import { Link } from "@tanstack/react-router"


import { getFullName, getShortName } from "@/hooks/useProfile.ts"
import { isUserPrincipal } from "@/lib/std.ts"
import { Navigator } from "@/routes/Navigator.ts"
import { useCurrentOrgId } from "@/routes/projects/projectHooks.ts"

import type { CPrincipal } from "@/lib/client/generated/TypeDefinitions.ts"

export const Principal = (props: {
  principal: CPrincipal
  stopPropagation?: boolean
  shortName?: boolean
}) => {
  const orgId = useCurrentOrgId()
  if (isUserPrincipal(props.principal)) {
    const profile = props.principal.details.user
    return (
      <ProfileLink {...Navigator.user(orgId, profile.username)} viewTransition onClick={e => {
        if (props.stopPropagation) {
          e.stopPropagation()
        }
      }}>
        {props.shortName ? getShortName(profile) : getFullName(profile)}
      </ProfileLink>
    )
  } else {
    return props.principal.name
  }
}

export const ProfileLink = styled(Link)`
  color: inherit;
`